module.exports = __webpack_public_path__ + "static/media/Payment.611cbae2.jpg";